module.exports = __webpack_public_path__ + "img/icon-forum.d7937802.svg";